import type {Recipe} from './types';

export const zucchineRipiene: Recipe = {
    id: 9,
    key: "zucchineRipiene",
    pictures: [
        {index: 0, url: "https://www.cuocicuoci.com/wp-content/uploads/2020/08/zucchine-ripiene-in-umido.jpg"},
    ],
    i18n: {
        IT: {
            title: "Zucchine Ripiene",
            servings: "4 porzioni",
            ingredients: [
                "4 zucchine medie",
                "300g di carne macinata",
                "50g di prosciutto cotto, tritato finemente",
                "50g di Parmigiano grattugiato",
                "Un pizzico di noce moscata",
                "2 uova",
                "Mezzo bicchiere di pangrattato",
                "Latte q.b. per ammorbidire il pangrattato e fare il sugo",
                "Sale q.b.",
                "Olio d'oliva per soffriggere",
            ],
            steps: [
                "Lava e asciuga le zucchine. Usa un coltello lungo e sottile per forare delicatamente il centro lungo tutta la loro lunghezza, senza rompere le estremità.\nEstrai il nucleo con un coltellino apposito o un cucchiaino, creando un canale centrale. Usa solo una parte dei centri delle zucchine per il ripieno.",
                "In una ciotola, mescola la carne macinata, il prosciutto cotto tritato, l'uovo, il parmigiano, il pangrattato precedentemente ammollato nel latte e strizzato,\nun pizzico di noce moscata e sale fino a ottenere un impasto omogeneo. Incorpora la polpa tritata delle zucchine al ripieno, mescolando bene.",
                "Riempi il canale centrale delle zucchine con il ripieno preparato, compattandolo bene.\nSigilla le estremità delle zucchine con parte del ripieno, formando un tappo di ripieno su ciascun capo per prevenire fuoriuscite durante la cottura.",
                "Riscalda un filo d'olio d'oliva in una padella larga e adagia le zucchine ripiene. Soffriggi per un po'.",
                "Aggiungi passata e latte fino a coprire 1 terzo delle zucchine.",
                "Cuoci coperto a fuoco medio-basso per circa 20-30 minuti, finché le zucchine non sono tenere e il ripieno ben cotto.",
            ],
            notes: "Aggiusta la quantità di latte in base alla consistenza desiderata del pangrattato e del sugo. \nAssicurati che l'impasto di carne non sia troppo morbido e usa le restanti zucchine per fare il sugo della pasta.",
        },
        EN: {
            title: "Stuffed Zucchini",
            servings: "4 servings",
            ingredients: [
                "4 medium zucchini",
                "300g ground meat",
                "50g finely chopped cooked ham",
                "50g grated Parmesan cheese",
                "A pinch of nutmeg",
                "2 eggs ",
                "Half a glass of breadcrumbs ",
                "Milk as needed to soften the breadcrumbs and make the sauce",
                "Salt to taste ",
                "Olive oil for frying",
            ],
            steps: [
                "Wash and dry the zucchinis. Use a long, thin knife to gently pierce the center along their entire length without breaking the ends.\nExtract the core with a special knife or a teaspoon, creating a central channel. Use only part of the zucchini cores for the filling.",
                "In a bowl, mix the ground meat, chopped cooked ham, egg, Parmesan cheese, breadcrumbs previously soaked in milk and squeezed,\na pinch of nutmeg, and salt until you get a homogeneous mixture. Incorporate the chopped zucchini pulp into the filling, mixing well.",
                "Fill the central channel of the zucchinis with the prepared filling, compacting it well.\nSeal the ends of the zucchinis with part of the filling, forming a filling plug at each end to prevent leakage during cooking.",
                "Heat a drizzle of olive oil in a large pan and place the stuffed zucchinis. Sauté for a bit.",
                "Add tomato sauce and milk until covering one-third of the zucchinis.",
                "Cook covered over medium-low heat for about 20-30 minutes, until the zucchinis are tender and the filling is well cooked.",
            ],
            notes: "Adjust the amount of milk depending on the desired consistency of the breadcrumbs and the sauce. \nEnsure the meat mixture is not too soft and use the remaining zucchini to make pasta sauce.",
        },
        PL: {
            title: "Cukinie Faszerowane",
            servings: "4 porcje",
            ingredients: [
                "4 średnie cukinie",
                "300g mielonego mięsa",
                "50g gotowanej szynki, drobno posiekanej",
                "50g startego Parmezanu",
                "Szczypta gałki muszkatołowej",
                "2 jajka",
                "Pół szklanki bułki tartej",
                "Mleko w razie potrzeby, aby zmiękczyć bułkę tartą i zrobić sos",
                "Sól do smaku",
                "Oliwa z oliwek do smażenia",
            ],
            steps: [
                "Umyj i osusz cukinie. Użyj długiego, cienkiego noża, aby delikatnie przebić środek na całej długości, nie łamiąc końców.\nWyciągnij rdzeń specjalnym nożem lub łyżeczką, tworząc centralny kanał. Użyj tylko części rdzeni cukinii do nadzienia.",
                "W misce wymieszaj mielone mięso, posiekaną gotowaną szynkę, jajko, ser parmezan, bułkę tartą wcześniej namoczoną w mleku i odciśniętą,\nszczyptę gałki muszkatołowej i sól, aż uzyskasz jednolitą masę. Dodaj posiekaną pulpę cukinii do nadzienia, dobrze mieszając.",
                "Wypełnij centralny kanał cukinii przygotowanym nadzieniem, dobrze go ubijając.\nZamknij końce cukinii częścią nadzienia, tworząc zatyczki z nadzienia na każdym końcu, aby zapobiec wyciekaniu podczas gotowania.",
                "Podgrzej odrobinę oliwy z oliwek na dużej patelni i umieść nadziane cukinie. Smaż przez chwilę.",
                "Dodaj passatę i mleko, aby pokryć jedną trzecią cukinii.",
                "Gotuj pod przykryciem na średnim-niskim ogniu przez około 20-30 minut, aż cukinie będą miękkie, a nadzienie dobrze ugotowane.",
            ],
            notes: "Dostosuj ilość mleka w zależności od pożądanej konsystencji bułki tartej i sosu. Upewnij się, \nże farsz mięsny nie jest zbyt miękki i użyj pozostałych cukinii do przygotowania sosu do makaronu.",
        },
    },
};
